import ThreeDotHHMTIcon from 'assets/icons/three-dot-hhmt-icon.svg';
import ThreeDotRemoxIcon from 'assets/icons/three-dot-remox-icon.svg';
import { fetchReceiverInformation } from 'components/Receivers/func';
import DropdownCommon, {
  DropdownItemStyled,
} from 'components/common/DropdownCommon';
import {
  RECEIVERS_EDIT_SUFIX,
  RECEIVERS_UPDATE_SUFIX,
  RECEIVER_ACTIONS,
} from 'constants';
import { Fade } from 'helpers/animation';
import useAuth from 'hooks/useAuth';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import useStore from 'hooks/useStore';
import useTheme from 'hooks/useTheme';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  displayFlexRowCenterSpaceBetweenMixinObject,
  paragraphMixin,
} from 'styles';

const CustomActionDropdown = ({
  text,
  textStyles = {},
  onDelete = () => {},
  onEdit,
  styleDropdown = {},
  styleDropdownToggle = {},
  styleDropdownMenu = {},
}) => {
  const { t } = useLang();
  const { state } = useStore();
  const { currentReceiver } = state;
  const { isHHMTTheme } = useTheme();
  const navigate = useNavigate();
  const { token } = useAuth();
  const { isDesktop } = useDetectDevice();

  const [isShowDropdown, setShowDropdown] = useState(false);

  const handleEditAction = async () => {
    if (onEdit) {
      onEdit();
      setShowDropdown(false);
      return;
    }

    setShowDropdown(false);
    fetchReceiverInformation(token, currentReceiver?.receiverId);

    if (!currentReceiver?.gender) {
      navigate(`${RECEIVERS_UPDATE_SUFIX}/${currentReceiver?.receiverId}`);
      return;
    }
    navigate(`${RECEIVERS_EDIT_SUFIX}/${currentReceiver?.receiverId}`);
  };

  const handleDeleteAction = () => {
    setShowDropdown(false);
    onDelete();
  };

  const handleDropdownOnToggle = () => {
    setShowDropdown(!isShowDropdown);
  };

  const renderDropdownToggleChildren = () => (
    <>
      {text && <ActionText style={textStyles}>{text}</ActionText>}
      <ThreeDotStyled
        src={isHHMTTheme ? ThreeDotHHMTIcon : ThreeDotRemoxIcon}
        width={24}
        height={24}
        alt=""
      />
    </>
  );
  const renderDropdownMenuChildren = () => {
    return (
      <>
        {RECEIVER_ACTIONS.map((action, index) => (
          <DropdownItemStyled
            key={index}
            eventKey={index}
            onClick={index === 0 ? handleEditAction : handleDeleteAction}
            style={{
              ...displayFlexRowCenterSpaceBetweenMixinObject,
              borderRadius: '8px',
            }}
          >
            {t(action.label)}
            <img src={action.icon} width={24} height={24} alt="" />
          </DropdownItemStyled>
        ))}
      </>
    );
  };

  const getStyleDropdown = () => {
    const common = { ...styleDropdown };
    if (!isDesktop)
      return {
        border: 'none',
        minHeight: '24px',
        ...common,
      };
    return {
      border: '1px solid var(--c-primary)',
      ...common,
    };
  };
  const getStyleDropdownToggle = () => {
    const common = { textTransform: 'initial', ...styleDropdownToggle };
    if (!isDesktop)
      return {
        padding: '0px',
        paddingRight: '0px',
        minHeight: '24px',
        ...common,
      };
    return {
      paddingRight: '8px',
      width: 'max-content',
      ...common,
    };
  };
  const getStyleDropdownMenu = () => {
    const common = { borderRadius: '8px', ...styleDropdownMenu };
    if (!isDesktop)
      return {
        transform: 'translate(-135px, 25px)',
        ...common,
      };
    return {
      transform: 'translate(-60px, 45px)',
      ...common,
    };
  };

  return (
    <ActionDropdownStyled>
      <DropdownCommon
        isShowDropdown={isShowDropdown}
        onToggle={handleDropdownOnToggle}
        renderDropdownToggleChildren={renderDropdownToggleChildren}
        renderDropdownMenuChildren={renderDropdownMenuChildren}
        styleDropdown={getStyleDropdown()}
        styleDropdownToggle={getStyleDropdownToggle()}
        styleDropdownMenu={getStyleDropdownMenu()}
      />
    </ActionDropdownStyled>
  );
};

const ActionDropdownStyled = styled.div`
  ${Fade};
`;

const ActionText = styled.p`
  ${paragraphMixin};
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: var(--c-action);
  padding: 0;
  margin: 0;
`;
const ThreeDotStyled = styled.img`
  padding-top: 3px;
  padding-bottom: 3px;
  object-fit: contain;
  filter: invert(12%) sepia(87%) saturate(6995%) hue-rotate(234deg)
    brightness(90%) contrast(113%);
`;

export default CustomActionDropdown;
